import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null,
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_INSCRIPCION(state, item) {
            state.value = item;
        },
        SET_INSCRIPCIONS(state, items = []) {
            state.items = items;
        },
        ADD_INSCRIPCION(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_INSCRIPCION(state, Id) {
            const ind = state.items.findIndex(inscripcion => inscripcion.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_INSCRIPCION(state, { Id, inscripcion }) {
            const ind = state.items.findIndex(inscripcion => inscripcion.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, inscripcion);
            }
        }
    },

    actions: {
        setInscripcionNull({ commit }) {
            return (commit('SET_NULL'), true)
        },

        selectInscripcion({ commit }, data) {
            // const savedItems = [...state.items]
            // let exitsItem = savedItems.find(item => item === data);
            return commit('SELECT_INSCRIPCION', data);
        },

        // first param is context object
        setInscripcions({ commit }, data) {
            commit('SET_INSCRIPCIONS', data);
            return true;
        },
        addInscripcion({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_INSCRIPCION', data), true) : false;
        },

        deleteInscripcion({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_INSCRIPCION', id), true) : false;
        },

        editInscripcion({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('EDIT_INSCRIPCION', data), true) : false;
        },

    }
};
